import { IconName } from '@fortawesome/free-solid-svg-icons'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type TErrorDescriptor = {
  type: 'error' | 'success' | 'info' | 'warning'
  title: string
  description?: string
  icon?: IconName
  duration?: undefined | 'long' | 'short'
}
export type TError = TErrorDescriptor & {
  id: number
}
type TErrorHandlingState = {
  errors: TError[]
}

export const durations = {
  long: 10000,
  short: 5000,
}

const createId = (() => {
  let counter = 0
  return () => {
    counter = counter + 1
    return counter
  }
})()

const initialState: TErrorHandlingState = {
  errors: [],
}

const { reducer: errorHandlingReducer, actions } = createSlice({
  name: 'errorHandling',
  initialState,
  reducers: {
    addError: (state, action: PayloadAction<TErrorDescriptor>) => {
      const id = createId()
      const error = { ...action.payload, id }
      state.errors.push(error)
    },
    removeError: (state, action: PayloadAction<number>) => {
      state.errors = state.errors.filter(error => error.id !== action.payload)
    },
  },
})

const errorsStateSelector = (state: { errorHandling: TErrorHandlingState }) =>
  state.errorHandling
const errorsSelector = (state: { errorHandling: TErrorHandlingState }) =>
  errorsStateSelector(state).errors

export default errorHandlingReducer
export const { addError, removeError } = actions
export { errorsSelector, errorsStateSelector }
